





















import { defineComponent, ref, computed, PropType } from '@vue/composition-api';
import axios from 'axios';
import { EnsuiPlant } from '@/models/apis/ensui/johaisetsuEnsuiPlantResponse';

export default defineComponent({
  props: {
    plant: { type: Object as PropType<EnsuiPlant>, required: true },
    title: { type: String as PropType<string>, required: true },
    label: { type: String as PropType<string>, required: true },
    initialQuantity: { type: Number as PropType<number | null>, required: true },
    submitHandler: {
      type: Function as PropType<(plantId: number, quantity: number | null) => Promise<unknown>>,
      required: true,
    },
  },
  emits: ['close', 'updated'],
  setup(props, { emit }) {
    const inputValue = ref<string>(props.initialQuantity != null ? String(props.initialQuantity) : '');
    const isUpdating = ref(false);
    const errorMessage = ref<string>('');
    const isInvalidQuantity = computed<boolean>(() => {
      if (inputValue.value === '') return false;
      const num = Number(inputValue.value);
      return num < 0 || !Number.isInteger(num);
    });

    const submit = async() => {
      const quantity = inputValue.value === '' ? null : Number(inputValue.value);
      isUpdating.value = true;
      try {
        const result = await props.submitHandler(props.plant.id, quantity);
        emit('updated', result);
      } catch (e) {
        const fallback = '更新に失敗しました。再度操作を行ってください';
        errorMessage.value = axios.isAxiosError(e) ? (e.response?.data?.message ?? fallback) : fallback;
      } finally {
        isUpdating.value = false;
      }
    };

    return {
      inputValue,
      isUpdating,
      errorMessage,
      isInvalidQuantity,
      submit,
    };
  },
});
